import { createSlice } from '@reduxjs/toolkit';
import { User } from 'global/types';

interface UserState {
    isAuthenticating: boolean;
    authenticated: boolean;
    user: User;
};

const initialState: UserState = {
    isAuthenticating: true, 
    authenticated: false,
    user: null
};

export const userSlice = createSlice({
    name: 'user',
    initialState, 
    reducers: {
        signIn: (state, action) => {
            state.isAuthenticating = false;
            state.authenticated = true;
            state.user = action.payload;
        },
        signOut: state => {
            state.isAuthenticating = false;
            state.authenticated = false;
            state.user = null;
        }
    }
});

export const { signIn, signOut } = userSlice.actions;

export default userSlice.reducer;